<template>
  <div class="summaryRegex">
    <div v-for="regex,index in value">
      <div class="field mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
        <input class="mdl-textfield__input" type="text" :id="'summary_'+index"
               :value="regex" @input="updateRegex(index, $event.target.value)"
               v-bind:required="required" :ref="'summary_'+index">
        <label class="mdl-textfield__label" :for="'summary_'+index">Summary regex</label>
      </div>
      <button class="mdl-button mdl-js-button mdl-button--fab mdl-button--raised mdl-button--accent del-regex"
              @click="deleteRegex(index)"><i class="material-icons">delete_forever</i></button>
      <div v-if="errors[index]" class="error">{{ errors[index] }}</div>
    </div>
    <button class="mdl-button mdl-js-button mdl-button--fab mdl-button--raised mdl-button--accent add-regex"
            @click="addRegex"><i class="material-icons">add</i></button>
  </div>
</template>

<script>
  export default {
    name: "SummaryRegex",
    props: {
      value: {
        type: Array
      }
    },
    data() {
      return {
        errors: [],
        required: true
      }
    },
    methods: {
      updateRegex(index, value) {
        this.value[index] = value
        this.computeErrors()
        this.value.errors = this.errors
        this.$emit('input', this.value)
      },
      computeErrors() {
        let regexs = new Set()
        let errors = new Array(this.value.length)
        for(let i = 0; i < this.value.length; i++) {
          let r = this.value[i]
          if( regexs.has(r) )
            errors[i] = `Duplicate Entry`
          regexs.add(r)
        }
        this.errors = errors
      },
      addRegex() {
        this.value.push("^Total")
        this.computeErrors()
        this.value.errors = this.errors
        this.$emit('input', this.value)
      },
      deleteRegex(index) {
        this.value.splice(index, 1)
        this.value.errors = this.errors
        this.$emit('input', this.value)
      }
    },
    updated () {
      componentHandler.upgradeAllRegistered()
    },
    mounted () {
      componentHandler.upgradeAllRegistered()
      this.computeErrors()
    }
  }
</script>

<style scoped>

  button.add-regex {
    width: 28px;
    max-width: 28px;
    min-width: 28px;
    height: 28px;
    margin-left: 4px;
  }
  button.add-regex > i {
    font-size: 20px;
  }

  button.del-regex {
    width: 28px;
    max-width: 28px;
    min-width: 28px;
    height: 28px;
    margin-left: 4px;
  }
  button.del-regex > i {
    font-size: 20px;
  }

  .error {
    position: relative;
    top: -16px;
    color: #af0000;
    font-size: 12px;
  }

</style>



// WEBPACK FOOTER //
// SummaryRegex.vue?1c42b2f0